module.exports = __webpack_public_path__ + "img/52200.f5961ee2.jpg";